import i18n from 'i18n';
import * as Yup from 'yup';

export const updateWimSchema = Yup.object({
  lanes: Yup.array().of(
    Yup.object({
      laneDescription: Yup.string().max(225, i18n.t('violationsPage.laneDescriptionErrorMaximumSymboles')).nullable(),
    })
  ),
});
